// classes/Icon.js

// Note: Icon must be defined in css -- _icons.scss

class Icon {
    /**
     * @param {HTMLElement} domNode
     */
    constructor(domNode) {
        this.domNode = domNode;
        this.init();
    }

    init() {
        if (!this.domNode) return;

        const bgImage = getComputedStyle(this.domNode).backgroundImage;

        // Extract the URL from `url("...")`
        const match = bgImage.match(/url\(["']?(.*?)["']?\)/);
        if (!match || !match[1]) return;

        const svgUrl = match[1];

        fetch(svgUrl)
            .then(response => {
                if (!response.ok) throw new Error("SVG fetch failed");
                return response.text();
            })
            .then(svgText => {
                this.domNode.innerHTML = svgText;
                this.domNode.classList.add("svg-converted");
                this.domNode.style.backgroundImage = "none"; // Optional: remove fallback
            })
            .catch(err => {
                console.error("Error injecting SVG:", err);
            });
    }
}

export { Icon };
